import React, { useState } from "react";

import { BuildingOfficeOutlineRegularIcon } from "assets/SVGComponents/index";
import Icon from "components/Icon/Icon";

export const CompanyNameCell = ({
  logo,
  name,
  suffix = "",
  title,
  showCompanyPlaceholder = false
}) => {
  const [imgError, setImgError] = useState(false);

  const handleError = (e) => {
    e.currentTarget.style.display = "none";
    setImgError(true);
  };

  return (
    <div className="company-cell">
      {logo && !imgError ? (
        <img src={logo} alt="logo" onError={handleError} />
      ) : showCompanyPlaceholder ? (
        <div className="placeholder-logo">
          <BuildingOfficeOutlineRegularIcon color="#D9B6FE" />
        </div>
      ) : (
        <img
          src={getUserPlaceholder()}
          className="user-fallback-img"
          alt="user profile fallback"
        />
      )}
      <div className="truncate-text" title={title}>
        {name}
        {suffix}
      </div>
    </div>
  );
};

export const renderValue = (value) => {
  if (value === null || value === undefined || value.toString().trim() === "") {
    return "-";
  }
  return value;
};

export const getFullName = (user) =>
  `${user?.first_name || ""} ${user?.last_name || ""}`.trim();

export const getUserPlaceholder = () => {
  return "https://live-hashfame.sgp1.digitaloceanspaces.com/creator_profiles/default_profile.png";
};
